var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapGridArea"},[_vm._m(0),_c('SBGrid',{ref:"grid",staticClass:"grids",staticStyle:{"width":"45%","height":"400px","margin-right":"20px"},attrs:{"id":"grid","data":_vm.gridJson,"columns":_vm.grid1columns,"gridattr":{
      showtotalrows:true,
      backcoloralternate: '#efefef',
      rowheight: '26',}}}),_c('SBGrid',{ref:"grid2",staticClass:"grids",staticStyle:{"width":"45%","height":"400px"},attrs:{"id":"grid2","data":[],"columns":_vm.grid1columns,"gridattr":{
      showtotalrows:true,
      backcoloralternate: '#efefef',
      rowheight: '26',}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v("2개의 Grid간의 Drag & Drop 테스트 "),_c('span',{staticStyle:{"font-size":"12px","color":"#aaa","font-style":"italic"}},[_vm._v("왼쪽 그리드 행 데이터를 드래그하여 오른쪽 그리드에 이동시켜 결과를 확인할 수 있습니다.")])])
}]

export { render, staticRenderFns }